import {
  Activity,
  Baby,
  Brain,
  Droplets,
  Flame,
  Gauge,
  HeartPulse,
  Ruler,
  Stethoscope,
  Syringe,
  Thermometer,
  Wind,
  type LucideIcon,
} from 'lucide-react';

export interface ToolDefinition {
  id: string;
  title: string;
  description: string;
  icon: LucideIcon;
  group: 'Resuscitation' | 'Assessment' | 'Medications' | 'Utilities';
  keywords: string[];
}

export const TOOLS: ToolDefinition[] = [
  { id: 'peds', title: 'Pediatric resuscitation', description: 'Length/age weight, vitals, equipment, energies, and drug card', icon: Baby, group: 'Resuscitation', keywords: ['broselow', 'length', 'pals', 'ett', 'defibrillation', 'drug card', 'child', 'infant'] },
  { id: 'rsi', title: 'RSI & Airway', description: 'Induction and paralytic doses, tube and SGA sizing, vent settings', icon: Stethoscope, group: 'Resuscitation', keywords: ['intubation', 'ett', 'igel', 'king', 'ventilator', 'ibw', 'rocuronium', 'ketamine', 'etomidate'] },
  { id: 'dosing', title: 'Weight-based dosing', description: 'Every dose rule for any medication, calculated for this patient', icon: Syringe, group: 'Medications', keywords: ['mg/kg', 'dose', 'volume', 'medication'] },
  { id: 'infusion', title: 'Infusions & drip rates', description: 'mcg/kg/min ↔ mL/hr and gravity drip rates', icon: Droplets, group: 'Medications', keywords: ['pump', 'gtt', 'drops', 'norepinephrine', 'pressor', 'mcg/min'] },
  { id: 'shock-index', title: 'Shock index', description: 'Shock index, modified shock index, and pediatric SIPA', icon: HeartPulse, group: 'Assessment', keywords: ['si', 'hr/sbp', 'hemorrhage', 'sipa'] },
  { id: 'map', title: 'Mean arterial pressure', description: 'MAP from systolic and diastolic pressure', icon: Gauge, group: 'Assessment', keywords: ['map', 'blood pressure', 'perfusion'] },
  { id: 'gcs', title: 'Glasgow Coma Scale', description: 'Adult and pediatric GCS', icon: Brain, group: 'Assessment', keywords: ['gcs', 'coma', 'mental status', 'tbi'] },
  { id: 'stroke', title: 'Stroke scales', description: 'BE-FAST, Cincinnati, LAMS, RACE, NIHSS, last known well', icon: Activity, group: 'Assessment', keywords: ['befast', 'cincinnati', 'lams', 'race', 'nihss', 'lvo', 'cva'] },
  { id: 'burns', title: 'Burns / TBSA', description: 'Rule of nines, Lund–Browder, and fluid resuscitation', icon: Flame, group: 'Assessment', keywords: ['tbsa', 'parkland', 'rule of nines', 'lund browder', 'fluids'] },
  { id: 'qsofa', title: 'qSOFA / Sepsis', description: 'Quick sepsis-related organ failure assessment', icon: Thermometer, group: 'Assessment', keywords: ['sepsis', 'qsofa', 'infection'] },
  { id: 'apgar', title: 'APGAR', description: 'Newborn assessment at 1 and 5 minutes', icon: Baby, group: 'Assessment', keywords: ['newborn', 'neonate', 'delivery', 'apgar'] },
  { id: 'oxygen', title: 'O₂ cylinder duration', description: 'Time remaining for D, E, M, G, H/K cylinders', icon: Wind, group: 'Utilities', keywords: ['oxygen', 'tank', 'cylinder', 'psi'] },
  { id: 'conversions', title: 'Unit conversions', description: 'Weight, temperature, length, and dose units', icon: Ruler, group: 'Utilities', keywords: ['lb', 'kg', 'fahrenheit', 'celsius', 'inches', 'mcg', 'mg'] },
];

export const TOOL_GROUPS = ['Resuscitation', 'Assessment', 'Medications', 'Utilities'] as const;

